import KendoDateAndOrTimePicker from '@/Components/KendoDateTimePicker/Controls/KendoDateAndOrTimePickerBase';
import ComponentManager from '@/Management/ComponentManager';
import KendoDatePickerViewModelType from '@/Components/KendoDateTimePicker/ViewModels/KendoDatePickerViewModel';
import LinkType from '@/Controls/Link';
import ResourceManager from '@/Management/ResourceManager';

export default class KendoDatePicker extends KendoDateAndOrTimePicker {

    private Link = ComponentManager.getControl<typeof LinkType>('Link');
    private link: LinkType;

    /**
     * @override
     */
    public widget: KnockoutObservable<kendo.ui.DatePickerExt>;

    public constructor(protected viewModel: KendoDatePickerViewModelType, protected element?: JQuery) {
        super(viewModel, element);
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.createControl(this.element, '<input type="text">');

        let language = ResourceManager.getInstance().getLanguage();

        this.applyBindings(this.jQueryControl.find('input'), {
            kendoDatePicker: {
                animation: this.viewModel.animation,

                value: this.viewModel.date,

                culture: language.cultureInfoName,

                min: this.viewModel.min,

                max: this.viewModel.max,

                format: language.datePattern,

                widget: this.widget
            },

            tooltip: this.viewModel.tooltip,

            focus: this.viewModel.isFocusable,

            attr: {
                placeholder: this.viewModel.placeholder,
                readonly: this.defineComputed(() => {
                    return !this.viewModel.isEnabled();
                })
            }
        });

        return this.jQueryControl;
    }

    protected onWidgetCreatedCallback(widget: kendo.ui.DatePickerExt): void {
        super.onWidgetCreatedCallback(widget);
        this.applyBindings(this.jQueryControl, {
            controlName: 'kendodatepicker',

            autoLocator: this.viewModel.locator,

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            visible: this.viewModel.isVisible,

            styles: this.definePureComputed({
                read: () => {
                    let styles = [];

                    return styles;
                }
            }),

            states: this.definePureComputed({
                read: () => {
                    let states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    if (this.viewModel.isValid() === true) {
                        states.push('valid');
                    } else {
                        states.push('invalid');
                    }

                    if (this.viewModel.isEnabled() === true) {
                        states.push('enabled');
                    } else {
                        states.push('disabled');
                    }

                    return states;
                }
            })
        });

        this.applyBindings(widget.wrapper, {
            invalid: this.viewModel.invalidationText
        });

        if (this.viewModel.link != null) {
            this.viewModel.link.onClick = () => {
                widget.open();
            };

            this.link = new this.Link(this.viewModel.link);
            let tuple = this.link.getTuple();

            tuple.control.appendTo(this.jQueryControl);
        }
    }
}

ComponentManager.setControl('KendoDatePicker', KendoDatePicker, 'RADPresentation.HTMLClient.DefaultViewExtensions');